import styled, { css } from "styled-components";
import { Search, InformationCircle } from "../../styles/Icons";
import {
  Input as InputAnt,
  Select as SelectAnt,
  Button as ButtonAnt,
} from "antd";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 0.5rem;

  @media (max-width: 768px) {
    .ant-checkbox-wrapper {
      margin-left: 0;
    }
  }
`;

export const ContainerSearch = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const CardContainer = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-direction: column;
`;

export const BoxSearch = styled.div`
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;

  @media (max-width: 992px) {
    width: 100%;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const ContainerActions = styled.div`
  display: flex;
  gap: 0.5rem;
  height: 2rem;

  justify-content: space-between;
  flex-wrap: wrap;
  @media (max-width: 1440px) {
    height: auto;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const BoxActions = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  @media (min-width: 768px) {
    flex-direction: row;
    align-items: center;
  }
`;

export const LabelCheckbox = styled.span`
  font-size: 0.9rem;
  color: var(--gray-550);

  @media (max-width: 576px) {
    font-size: 0.8rem;
  }
`;

export const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;

  @media (max-width: 576px) {
    width: 100%;
    justify-content: space-between;
  }
`;

export const ActionInfo = styled.div``;

export const UsersSelected = styled.span`
  font-size: 0.9rem;
  color: var(--gray-550);
`;

export const Input = styled(InputAnt)`
  width: 20rem;

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const Select = styled(SelectAnt)`
  width: 10rem;
  border: 0.0625rem solid rgba(205, 207, 213, 0.5);
  .ant-select-arrow {
    color: var(--gray-550);
  }
  .ant-select-selector {
    height: 100% !important;
  }

  @media (max-width: 992px) {
    width: 100%;
  }
`;

export const ActionButtonsContainer = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 992px) {
    width: 100%;
    justify-content: space-between;
  }

  @media (max-width: 576px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

export const SearchIcon = styled(Search)`
  width: 1.2rem;
  height: 1.2rem;
  color: var(--gray-550);

  @media only screen and (max-width: 1366px) {
    width: 1rem;
    height: 1rem;
  }
`;

interface IButton {
  actionType:
    | "default"
    | "send"
    | "inactivate"
    | "activate"
    | "activate_courses_mass"
    | "update_magic_link";
}

export const Button = styled(ButtonAnt)<IButton>`
  border-radius: 0.3rem;
  white-space: normal;
  height: auto;
  padding: 0.25rem 0.9375rem;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 2rem;

  &&&:disabled {
    background-color: #d4d4d4;
    color: #a09d9d;
    &&&:hover {
      background-color: #d4d4d4;
    }
  }

  ${({ actionType }) => {
    if (actionType === "default") {
      return css`
        background-color: var(--gray-100);
      `;
    }
    if (actionType === "send" || actionType === "update_magic_link") {
      return css`
        background-color: #1890ff;
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(53, 134, 209);
        }
      `;
    }
    if (actionType === "inactivate") {
      return css`
        background-color: var(--red-600);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(209, 53, 53);
        }
      `;
    }
    if (actionType === "activate") {
      return css`
        background-color: var(--green-700);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(45, 124, 45);
        }
      `;
    }
    if (actionType === "activate_courses_mass") {
      return css`
        background-color: var(--orange-150);
        &&&:hover,
        &&&:focus,
        &&&:active,
        &&&:focus-within {
          background-color: rgb(255, 132, 0);
        }
      `;
    }
  }}

  @media (max-width: 576px) {
    width: 100%;
    font-size: 0.9rem;
    padding: 0.25rem 0.5rem;
    min-height: 2.25rem;
  }
`;

export const InfoIcon = styled(InformationCircle)`
  width: 1.2rem;
  height: 1.2rem;
  color: var(--orange-100);
  margin-left: 0.5rem;
  cursor: pointer;
  transition: color 0.3s;
  display: flex;
  align-self: center;

  &:hover {
    color: var(--orange-250);
  }

  &.pulse {
    animation: pulse 1.5s infinite;

    @keyframes pulse {
      0% {
        transform: scale(1);
        opacity: 1;
      }
      50% {
        transform: scale(1.2);
        opacity: 0.8;
      }
      100% {
        transform: scale(1);
        opacity: 1;
      }
    }
  }

  @media (max-width: 576px) {
    margin: 0.5rem 0;
    align-self: flex-start;
  }
`;

export const TwygoHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const HelpContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`;

export const HelpTooltip = styled.div`
  position: absolute;
  top: -3rem;
  left: 1.1rem;
  transform: translateX(-50%);
  background-color: var(--orange-100);
  color: white;
  padding: 0.5rem 0.75rem;
  border-radius: 0.25rem;
  font-size: 0.875rem;
  white-space: nowrap;
  z-index: 10;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  animation: fadeIn 0.3s ease-in-out;

  &::before {
    content: "";
    position: absolute;
    bottom: -0.5rem;
    left: 50%;
    transform: translateX(-50%);
    border-width: 0.25rem;
    border-style: solid;
    border-color: var(--orange-100) transparent transparent transparent;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translate(-50%, -0.5rem);
    }
    to {
      opacity: 1;
      transform: translate(-50%, 0);
    }
  }

  @media (max-width: 576px) {
    font-size: 0.75rem;
    padding: 0.4rem 0.6rem;
    width: 8rem;
    white-space: normal;
    text-align: center;
    line-height: 1.2;
  }
`;
